import {
  ORGANIZATION_ALTERNATE_NAME,
  ORGANIZATION_ANNOUNCEMENT_URL,
  ORGANIZATION_FORMER_NAME,
  ORGANIZATION_ID,
  ORGANIZATION_NAME,
  SERVICE_OGP_IMAGE,
  SITE_URL,
} from '../constants'

/** TOP ページ用 Corporation スキーマ（@id 付き） */
export const topCorporationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Corporation',
  '@id': ORGANIZATION_ID,
  name: ORGANIZATION_NAME,
  legalName: ORGANIZATION_NAME,
  alternateName: ORGANIZATION_ALTERNATE_NAME,
  formerName: ORGANIZATION_FORMER_NAME,
  subjectOf: {
    '@type': 'WebPage',
    name: '社名変更のお知らせ',
    url: ORGANIZATION_ANNOUNCEMENT_URL,
  },
  slogan: 'Design × AI × Engineering で、日本のITを再起動する。AitriaはAI駆動のデジタルエンジニアリング企業です。',
  description:
    'AIエージェント、モダンスタック、CI/CD、DevOps、UX/UIをフル活用した開発スタイルで、顧客のモダナイゼーションとAIシフトを実装します。',
  founder: '芝 陽一郎',
  foundingDate: '2006-07-26',
  url: `${SITE_URL}/`,
  logo: SERVICE_OGP_IMAGE,
  image: SERVICE_OGP_IMAGE,
  telephone: '+81-3-6419-7700',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '東京',
    addressRegion: '東京都',
    addressCountry: 'JP',
    postalCode: '1070052',
    streetAddress: '東京都港区赤坂八丁目１番22号 NMF青山一丁目ビル３階',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    url: `${SITE_URL}/contact/`,
    telephone: '+81-3-6419-7700',
    areaServed: 'JP',
    availableLanguage: ['Japanese', 'English'],
  },
  areaServed: {
    '@type': 'Country',
    name: 'Japan',
  },
  knowsAbout: ['アプリ開発', 'クラウドネイティブ', 'AI駆動開発', 'デザインシステム', 'UX/UIデザイン'],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Aitriaサービス',
    itemListElement: [
      {
        '@type': 'OfferCatalog',
        name: 'AIDD',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'AI駆動開発TOP',
              url: `${SITE_URL}/services/aidd/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'AI駆動開発内製化サービス',
              url: `${SITE_URL}/services/aidd/internalization/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'AIエージェント基盤構築サービス',
              url: `${SITE_URL}/services/aidd/ai-agent-infrastructure/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'AI駆動開発研修',
              url: `${SITE_URL}/services/aidd/training/`,
            },
          },
        ],
      },
      {
        '@type': 'OfferCatalog',
        name: 'STUDIO',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'AI-UXスプリント',
              url: `${SITE_URL}/services/studio/ux-sprint/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'UX/UIワークショップ',
              url: `${SITE_URL}/services/studio/ux-workshop/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'アプリケーション開発',
              url: `${SITE_URL}/services/studio/application-development/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'モダナイゼーション',
              url: `${SITE_URL}/services/studio/modernization/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'UX/UI改善',
              url: `${SITE_URL}/services/studio/uxui-improvement/`,
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'デザインシステム構築支援',
              url: `${SITE_URL}/services/studio/design-system/`,
            },
          },
        ],
      },
      {
        '@type': 'OfferCatalog',
        name: 'FORGE',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'クラウドネイティブ',
              url: `${SITE_URL}/services/forge/cloudnative/`,
            },
          },
        ],
      },
      {
        '@type': 'OfferCatalog',
        name: 'Products',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'Phennec', url: 'https://phennec.ai/' },
          },
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'flamingo', url: `${SITE_URL}/products/flamingo/` },
          },
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'ZEBRA', url: `${SITE_URL}/products/zebra/` },
          },
          {
            '@type': 'Offer',
            itemOffered: { '@type': 'Service', name: 'ELAND', url: 'https://eland.jp/' },
          },
        ],
      },
    ],
  },
  memberOf: [
    { '@type': 'Organization', name: 'AWSセレクトティアサービスパートナー' },
    { '@type': 'Organization', name: 'Amazon ECS Delivery Partner' },
    { '@type': 'Organization', name: 'GitLab Open Partner' },
    { '@type': 'Organization', name: '特定非営利活動法人 人間中心設計推進機構' },
    { '@type': 'Organization', name: 'AI駆動開発コンソーシアム' },
  ],
  sameAs: [
    'https://x.com/aitria_jp',
    'https://www.facebook.com/Aitria.jp',
    'https://www.wantedly.com/companies/aitria',
    'https://tech.aitria.co.jp/',
    'https://note.com/aitria_jp',
    'https://note.com/aitria_design',
    'https://www.linkedin.com/company/aitria-co-ltd-/',
  ],
}
